import {
  bindService,
  type AppFeatureDefinition,
  type ServiceBinding,
} from "@nasam/kernel";
import { catalogRepositoryToken } from "../../contracts";
import { createCatalogHttpRepository } from "./data";
import { createCatalogRoutes } from "./presentation/routes";
import { MODULE_MANAGEMENT_UPDATE } from "./catalogPermissions";

export { catalogRepositoryToken };
export * from "./catalogPermissions";

function createCatalogServiceBindings(
  httpClient: Parameters<
    NonNullable<AppFeatureDefinition["provideServices"]>
  >[0]["httpClient"],
): readonly ServiceBinding[] {
  return [
    bindService(
      catalogRepositoryToken,
      createCatalogHttpRepository(httpClient),
    ),
  ];
}

export const catalogFeature: AppFeatureDefinition = {
  id: "catalog",
  version: "0.1.0",
  titleKey: "catalog:moduleTitle",
  icon: "Package",
  basePath: "/modules",
  requiredPermissions: [MODULE_MANAGEMENT_UPDATE],
  // Every CORE feature shares one "core" rail node (see mergeFeatureNavNodes);
  // this feature contributes the "Modules" leaf under it.
  navigation: [
    {
      id: "core",
      titleKey: "common:businessModules.core",
      icon: "Layers",
      placement: "rail",
      order: 10,
      children: [
        {
          id: "catalog",
          titleKey: "catalog:moduleTitle",
          icon: "Package",
          placement: "drawer",
          // Moved up from 90 to sit right after Organization, matching the
          // current design's drawer order (a non-round value on purpose —
          // see mergeFeatureNavNodes for why the "core" children stay
          // spaced by 10 normally, leaving room for exactly this kind of
          // single-item reslot without renumbering everyone else).
          order: 12,
          path: "/modules",
          requiredPermissions: [MODULE_MANAGEMENT_UPDATE],
        },
      ],
    },
  ],
  routes: (context) =>
    createCatalogRoutes({
      context,
      catalog: context.services.resolve(catalogRepositoryToken),
    }),
  i18n: {
    namespace: "catalog",
    load: {
      en: () => import("../../i18n/locales/en/catalog"),
      ar: () => import("../../i18n/locales/ar/catalog"),
    },
  },
  permissionCatalog: [
    {
      segment: "core",
      labelKey: "catalog:permissions.core",
      children: [
        {
          segment: "module_management",
          labelKey: "catalog:permissions.moduleManagement",
          children: [
            {
              segment: "module_management_list",
              labelKey: "catalog:permissions.modules",
              actions: [{ id: "update", labelKey: "catalog:actions.update" }],
            },
          ],
        },
      ],
    },
  ],
  provideServices: ({ httpClient }) => createCatalogServiceBindings(httpClient),
};
